<style>
	figure {
		position: absolute;
		top: 0;
		left: 0;
		width: 120px;
		height: 140px;
		transition-property: transform, opacity, filter;
		transition-duration: .4s;
		transition-timing-function: ease;
		z-index: 2;
		cursor: pointer;
		}
		figure > .avatar {
			pointer-events: none;
			position: relative;
			margin: 0 auto;
			width: 84px;
			height: 84px;
			background: white;
			border-radius: 100%;
			}
			figure > .avatar > img {
				position: absolute;
				left: 8px;
				top: 8px;
				display: block;
				width: 60px;
				height: 60px;
				border-radius: 100%;
				border: 4px solid white;
				box-shadow: 0 0 0 4px var(--color-breed-1);
				transition: opacity .4s ease;
				pointer-events: none;
				}
		figure > figcaption {
			display: flex;
			/* display: block; */
			/* align-items: center; */
			pointer-events: none;
			padding: 8px;
			height: 40px;
			background: white;
			border-radius: 28px;
			}
			figure > figcaption > h3 {
				margin: 0;
				width: 100%;
				font-size: 14px;
				font-weight: normal;
				letter-spacing: .25px;
				line-height: 20px;
				text-align: center;
				transition: opacity .4s ease;
				}
		figure.active {
			z-index: 10;
			}
			figure.active > .avatar {

				}
				figure.active > .avatar > img {
					box-shadow: 0 0 0 4px #FB835B;
					}
		figure.secondary,
		figure.hidden {
			filter: grayscale(1);
			}
			figure.secondary > .avatar,
			figure.hidden > .avatar {

				}
				figure.secondary > .avatar > img,
				figure.hidden > .avatar > img {
					opacity: .2;
					}
			figure.secondary > figcaption,
			figure.hidden > figcaption {

				}
				figure.secondary > figcaption > h3,
				figure.hidden > figcaption > h3 {
					opacity: .2;
					}
		figure.hidden {
			opacity: 0;
			transform: scale(0.2);
			}
</style>

<script lang="ts">
	export let breed = undefined;
	export let highlight: number = 1;
	$: position = breed[`position${highlight}`];
	$: scale = (position.visibility == 'hidden') ? 0.8 : 1.0;
</script>

<figure class="breed {position.visibility}" style="transform: translate({position.left}px, {position.top}px) scale({scale});">
	<div class="avatar">
		<img src="/img/{breed.slug}-head.png" alt="Head of {breed.name}" />
	</div>
	<figcaption>
		<h3>{breed.name}</h3>
	</figcaption>
</figure>